import React from 'react'

import { Input } from '@/ui'

import QueryFilter from '@/components/QueryFilter'

// 后续可能添加【颜色规格】【商品简称】查询条件
const goodsFields = [
    {
        name: 'styleCodes',
        component: Input,
        props: {
            placeholder: '资料编码'
        },
        num: 3
    },
    {
        name: 'itemCodes',
        component: Input,
        props: {
            placeholder: '商品编码'
        },
        num: 3
    },
    {
        name: 'itemName',
        component: Input,
        props: {
            placeholder: '商品名称'
        },
        num: 3
    },
    {
        name: 'shortName',
        component: Input,
        props: {
            placeholder: '商品简称'
        },
        num: 3
    },
    {
        name: 'propertiesValue',
        component: Input,
        props: {
            placeholder: '颜色规格'
        },
        num: 3
    }
]
const styleFields = [
    {
        name: 'styleCodes',
        component: Input,
        props: {
            placeholder: '资料编码'
        },
        num: 3
    },
    {
        name: 'itemCodes',
        component: Input,
        props: {
            placeholder: '商品编码'
        },
        num: 3
    },
    {
        name: 'itemName',
        component: Input,
        props: {
            placeholder: '商品名称'
        },
        num: 3
    }
]

export default ({ value, onChange, modalType }) => {
    return (
        <QueryFilter
            name="ErpQuery"
            showScan={false}
            fields={modalType === 'goods' ? goodsFields : styleFields}
            initialValues={value}
            onChange={onChange}
            preserve={false}
            searchType="default"
        />
    )
}
